module.exports = __webpack_public_path__ + "img/0-07.af0a8e72.jpg";